export default "__VITE_ASSET__B7g4o13R__"